import { useCallback, useEffect, useRef } from 'react';

/**
 * Hook that returns a function to check if the component is still mounted.
 * Useful to avoid setting state on unmounted components after async operations.
 */
export const useIsMounted = () => {
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return useCallback(() => isMountedRef.current, []);
};
